import React, { useRef, useEffect, FC, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../redux/RootState';
import { powerBiService } from '../lib/powerBi/powerBiService';
import styled from 'styled-components/macro';
import { models, IEmbedConfiguration } from 'powerbi-client';
import { PowerBiActions } from '../redux/actions/powerBi';
import { Spinner } from './styled/Spinner';
import { UserActions } from '../redux/actions/user';
import { LinkButton } from './styled/LinkButton';
export const PowerBiReport: FC = () => {
    const embedInfo = useSelector((s: RootState) => s.powerBi.currentReportEmbedInfo);
    const currentReport = useSelector((s: RootState) => s.powerBi.currentReport);
    const allReports = useSelector((s: RootState) => s.powerBi.reports);
    const isLoggedOn = useSelector((s: RootState) => s.user.isLoggedOn);
    const reportRef = useRef<HTMLDivElement>(null);
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(true);
    useEffect(() => {
        const el = reportRef.current;
        if (!el) {
            return;
        }
        powerBiService.bootstrap(el, { type: 'report' });
        const events: [string, () => void][] = [
            [
                'rendered',
                () => {
                    dispatch(PowerBiActions.reportLoaded());
                    setIsLoading(false);
                },
            ],
        ];
        events.forEach(([eventName, handler]) => el.addEventListener(eventName, handler));
        return () => {
            events.forEach(([eventName, handler]) => el.removeEventListener(eventName, handler));
            powerBiService.reset(el);
        };
    }, [dispatch]);
    useEffect(() => {
        setIsLoading(true);
        const el = reportRef.current;
        if (!embedInfo || !el) {
            return;
        }
        const embedConfig: IEmbedConfiguration = {
            type: 'report',
            tokenType: 1, // 1 == embed token type
            accessToken: embedInfo.embedToken,
            embedUrl: embedInfo.embedUrl,
            settings: {
                background: models.BackgroundType.Transparent,
                filterPaneEnabled: false,
                navContentPaneEnabled: false,
            },
        };

        powerBiService.embed(el, embedConfig);
    }, [embedInfo]);
    const classNamesArr = isLoading ? ['loading'] : [];
    const classNames = classNamesArr.join(' ');
    return (
        <Outer>
            {embedInfo && isLoading && (
                <>
                    <span>Loading report...</span>
                    <Spinner />
                </>
            )}
            {isLoggedOn != null ? (
                isLoggedOn ? (
                    allReports.length === 0 ? (
                        <span>Fetching your reports</span>
                    ) : (
                        !currentReport && <span>Please select a report to view</span>
                    )
                ) : (
                    <span>
                        Please{' '}
                        <SignInButton type="button" onClick={() => dispatch(UserActions.logOnOff(!isLoggedOn))}>
                            sign in
                        </SignInButton>{' '}
                        to view your reports
                    </span>
                )
            ) : (
                <span>Getting user status</span>
            )}
            <ReportContainer className={classNames} ref={reportRef}></ReportContainer>
        </Outer>
    );
};
const SignInButton = styled(LinkButton)`
    text-decoration: underline;
`;
const Outer = styled.div`
    display: flex;
    width: 100%;
    height: 100%;
    align-items: center;
    justify-content: center;
`;
const ReportContainer = styled.div`
    width: 100%;
    min-width: 1000px;
    height: 100%;
    min-height: 600px;
    background-color: ${(props) => props.theme.colors.secondary.backgroundColor};
    color: ${(props) => props.theme.colors.secondary.color};
    iframe {
        border: none;
    }
    &.loading {
        visibility: collapse;
    }
    display: grid;
`;
